export enum AUTOCOMPLETE {
  AMBULATORY = 'AMBULATORY',
  SPECIALIZATION = 'SPECIALIZATION',
  SPECIALITY = 'SPECIALITY',
  LOCATION = 'LOCATION',
  SPECIALITIES = 'SPECIALITIES',
  DISTRICTS_CITIES = 'DISTRICTS_CITIES',
}

export enum DeliveryModeTypes {
  Domiciliary = 'Domiciliary',
  Onsite = 'Onsite',
  Online = 'Online',
}

export enum CheckoutFlowType {
  RESERVATION = 'RESERVATION',
  RESERVATION_DEFERRED_PAYMENT = 'RESERVATION_DEFERRED_PAYMENT',
}
export enum PaymentMethod {
  STRIPE = 'stripe',
  TANTOSVAGO = 'tantosvago',
  WELBEE = 'welbee',
  INPLACE = 'inplace',
}
export enum CheckoutStatusType {
  COMPLETED = 'completed',
  NOT_COMPLETED = 'not_completed',
}

export enum TaxCodeCalculatorStep {
  CALCULATE = 'calculate',
  RECAP = 'recap',
  MANUAL_INSERT = 'manual_insert',
}
